
const app = {
    appId: 'Zbn5m5DKI9hVriBC',
    appKey: 'fmFf90jDAtncKflAt3y4T0365Fb6RmKA'
}
  // const url = 'http://127.0.0.1:12345';
  const url = 'https://testnlu.gree.com';
module.exports = {
    app,
    url
}
